import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const Header: React.FC = () => {
    const [menu, setMenu] = useState<boolean>(false);
    const navigate = useNavigate();

    const dosomething = (path: string) => {
        navigate(path);
        handleSwitch();
    }
    const handleSwitch = () => {
        setMenu(!menu);
    }

    return (
        <header>
            <img className="logo" src="/logo_Edisoft.png" alt="Edisoft Logo" onClick={() => { dosomething('/') }} />
            <nav>
                <ul className={menu ? 'on' : ''}>
                    <li>
                        {/* ABOUT US */}
                        <div onClick={() => { dosomething('/about') }}>關於我們</div>
                    </li>
                    <li>
                        {/* PRODUCT */}
                        <div onClick={() => { dosomething('/product') }}>產品簡介</div>
                    </li>
                    <li>
                        {/* CONTACT US */}
                        <div onClick={() => { dosomething('/contact') }}>聯絡我們</div>
                    </li>
                </ul>
                <label htmlFor="nav-toggle" className="ham" onClick={handleSwitch}>
                    <div className="ham-origin">
                        <div className="ham-bar ham-bar--top"></div>
                        <div className="ham-bar ham-bar--middle"></div>
                        <div className="ham-bar ham-bar--bottom"></div>
                    </div>
                </label>
            </nav>
        </header>
    );
};

export default Header;